import React, {useEffect} from "react";
import {ensureResultButtonsClickable, navigateSafely} from "../../services/PayGuard";
import {useLocation, useNavigate} from "react-router-dom";
import withAuth from '../../auth/UserRouteAuth'
import {useTranslation} from "react-i18next";

import Lottie from "lottie-react";
import commonFailed from "../../assets/motion/commonFailed.json";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

/**
 * ════════════════════════════════════════════════════════════════════════════════
 *  결제실패 안내 페이지 (웹)
 * ════════════════════════════════════════════════════════════════════════════════
 *  [노출 시점]
 *   PG(페이팔/페이레터)에서는 결제가 성공했으나 비토리지 주문서 저장이 실패하여,
 *   주문서 데이터 유실을 막기 위해 '결제대기' 상태로 강제저장한 직후.
 *
 *  [레이아웃]
 *   UserPayComplPg / UserPayWaitPg 와 완전히 동일한 up-result 구조를 사용하여 일관성 유지.
 * ════════════════════════════════════════════════════════════════════════════════
 */
function UserPayFailedPg() {

    const {t} = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [theme] = useTheme();

    /*
     * 결제 직후 이 화면으로 넘어오면 버튼이 먹통이 되는 일이 있었다.
     * 페이팔이 <body> 에 남긴 덮개가 원인인데, 라우팅으로는 지워지지 않아
     * 새로고침해야 풀렸다. 화면에 들어올 때 한 번 치우고 확인한다.
     */
    useEffect(() => ensureResultButtonsClickable(), []);

    const state = location.state || {};
    const data = state.data || {};

    // 결제수단 : 강제저장된 주문데이터 우선, 없으면 결제 시 선택했던 수단
    const payWay = data.payWay || state.payMethod;
    // 최종금액 : 실제 결제한 금액(state) 우선, 없으면 저장된 주문데이터
    const lastPrice = state.lastPrice != null ? state.lastPrice : data.lastPrice;
    const lastForPrice = state.lastForPrice != null ? state.lastForPrice : data.lastForPrice;
    const forCurrency = state.forCurrency || data.forCurrency;

    const orderDetailPgMove = (ordNum) => () => {
        navigateSafely(navigate, `/UserMyOrderPg/${ordNum}`);
    };

    const payWayLabel = (way) => (
        way === "PM00" ? t(`modNoBank`) :
            way === "PM01" ? "Paypal" :
                way === "PM02" ? "WechatPay" :
                    way === "PM03" ? "AliPay" :
                        way === "PM04" ? t(`modPt`) :
                            way === "PM05" ? t(`modDep`) :
                                way === "PM06" ? "BtoragePay(Global)" :
                                    way === "PM07" ? "BtoragePay(Korean)" :
                                        way === "PM08" ? "GlobalCard" :
                                            way === "PM09" ? "KoreanPay" : null
    );

    // 외화금액은 BtoragePay(Global) / GlobalCard / Paypal 3개 결제수단만 존재
    const hasForeignAmount = payWay === "PM01" || payWay === "PM06" || payWay === "PM08";

    const formatPrice = (value) =>
        value == null ? "0" : value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-result-wrap">
                <div className="up-result">
                    <div className="up-card up-result-card">
                        <div className="up-result-hero">
                            <Lottie animationData={commonFailed} loop autoplay className="wd-300 ht-120 opa09"/>
                            <p style={{fontSize: "16px", lineHeight: 1.5, textAlign: "center", whiteSpace: "pre-line"}}>
                                {t(`payFailCont`)}
                            </p>
                        </div>
                        <div className="up-result-rows">
                            <div className="up-result-row">
                                <span className="k">{t(`modNum`)}</span>
                                <span className="v">{data?.orderNumber || "-"}</span>
                            </div>
                            <div className="up-result-row">
                                <span className="k">{t(`modPty`)}</span>
                                <span className="v">{payWayLabel(payWay) || "-"}</span>
                            </div>
                            <div className="up-result-row">
                                <span className="k">{t(`pcWon`)}</span> {/*최종원화금액*/}
                                <span className="v">{"₩ " + formatPrice(lastPrice)}</span>
                            </div>
                            {hasForeignAmount ?
                                <div className="up-result-row">
                                    <span className="k">{t(`pcFor`)}</span> {/*최종외화금액*/}
                                    <span className="v">{lastForPrice} {forCurrency}</span>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                    <div className="up-btn-row">
                        <button onClick={() => navigateSafely(navigate, "/UserMyPg")} className="up-btn-ghost"
                                style={{height: "50px", fontSize: "16px", cursor: "pointer"}}>
                            {t(`hdMypg`)}
                        </button>
                        <button onClick={orderDetailPgMove(data?.orderNumber)} className="up-btn-primary"
                                style={{height: "50px", fontSize: "16px", cursor: "pointer"}}
                                disabled={!data?.orderNumber}>
                            {t(`modHeader`)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withAuth(UserPayFailedPg)
